module.exports = __webpack_public_path__ + "static/media/catalouge-26.32043493.jpg";